import React from 'react';
import { withRouter } from 'react-router';
import { Meteor } from 'meteor/meteor';
import moment from 'moment';
import { FlightTypeColor } from '../reservations/components/flightTypeColorComponent';

import {
	Col,
	BPanel,
	Radio,
	FormGroup,
	FormControl,
	ControlLabel,
	Modal,
	Button
} from '@sketchpixy/rubix';
var DatePicker = require("react-bootstrap-date-picker");

import { Flights } from '../../collections/flights/flights';
import { Montgolfieres } from '../../collections/montgolfieres/montgolfieres';
import { Users } from '../../collections/users/users';

import { scheduleReservation } from '../../collections/reservations/methods';
import { getAvailabilityCount } from '../../helpers/availabilities';

@withRouter
export class CreateFlightComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
		this.state.availabilities = {
			date: null,
			anjou: {
				morning: 0,
				evening: 0
			},
			nantes: {
				morning: 0,
				evening: 0
			},
		};
		this.state.subscription = Meteor.subscribe('availableAndScheduledAt', null);
	}

	componentWillUnmount() {
		this.state.subscription.stop();
	}

	closeProgramme() {
		this.setState({ showProgrammeModal: false });
	}


	openProgramme() {
		this.setState({ showProgrammeModal: true });
		this.calculateAvailabilities(this.state.availabilities.date);
	}

	getAvailabilityClass(availability) {
		if (availability >= 1)
			return "success";
		else
			return "danger";
	}

	calculateAvailabilities(date) {
		let availabilities = this.state.availabilities;

		date = date ? new Date(date) : null;

		if(moment(date).diff(moment(), 'days') < 0) {

			Messenger().post({
            	message: "Il n'est pas possible de programmer dans le passé.",
            	type: "error"
          	});

			return ;
		}

		if(this.props.reservation.period == "Semaine uniquement" && (date.getDay() == 0 || date.getDay() == 6)) {

			/*Messenger().post({
            	message: "Cette réservation est disponible en semaine uniquement",
            	type: "error"
          	});

			return ;*/
		}

		this.state.subscription = Meteor.subscribe('availableAndScheduledAt', date, () => {
			availabilities.date = date ? date.toISOString() : null;
			availabilities.anjou = {
				morning: getAvailabilityCount(date, "anjou", "morning"),
				evening: getAvailabilityCount(date, "anjou", "evening"),
			};
			availabilities.nantes = {
				morning: getAvailabilityCount(date, "nantes", "morning"),
				evening: getAvailabilityCount(date, "nantes", "evening"),
			};

			this.setState({ availabilities });

			console.log('availabilities', availabilities);
		});
	}

	scheduleReservation(place, period) {

		console.log('period', period);

		scheduleReservation.call({
			_id: this.props.reservation._id,
			date: new Date(this.state.availabilities.date),
			place,
			period
		}, (err) => {
			if (err)
				return Messenger().post({
					message: err,
					type: "error"
				});

			Messenger().post({
				message: "La reservation a été programmé avec succès.",
				type: "success"
			});

			this.closeProgramme();
			this.props.router.push('/planning?date=' + this.state.availabilities.date);
		});
	}

	renderProgrammeModal() {
		return (
			<Modal show={this.state.showProgrammeModal} onHide={::this.closeProgramme}>
				<Modal.Header closeButton>
					<Modal.Title style={{'display':'flex', 'align-items': 'center'}}
					>Programmer la réservation n°{this.props.reservation.id_billet} / <FlightTypeColor flightType={this.props.reservation.getFlightType()}/>
					<span> {this.props.reservation.flightName}</span></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Col sm={4}>
						<p>Choix d'une date :</p>
					</Col>
					<Col sm={8}>
						<DatePicker
							dayLabels={['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']}
							monthLabels={['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']}
							id="date_picker"
							weekStartsOn="1"
							daysOfWeekDisabled={[0, 5]}
							value={this.state.availabilities.date}
							onChange={(value) => this.calculateAvailabilities(value)} />
					</Col>

					<hr/>

					{ this.state.availabilities.date &&
						<div>
							<Col sm={6}>
								<BPanel header="Sites d'Anjou">
									<center>
										<Button bsStyle={this.getAvailabilityClass(this.state.availabilities.anjou.morning)} onClick={() => this.scheduleReservation("anjou", "morning")}>
											Matin : { this.state.availabilities.anjou.morning } places
										</Button>
									</center>
									<hr/>
									<center>
										<Button bsStyle={this.getAvailabilityClass(this.state.availabilities.anjou.evening)} onClick={() => this.scheduleReservation("anjou", "evening")}>
											Soir : { this.state.availabilities.anjou.evening } places
										</Button>
									</center>
								</BPanel>
							</Col>

							<Col sm={6}>
								<BPanel header="Sites de Nantes">
									<center>
										<Button bsStyle={this.getAvailabilityClass(this.state.availabilities.nantes.morning)} onClick={() => this.scheduleReservation("nantes", "morning")}>
											Matin : { this.state.availabilities.nantes.morning } places
										</Button>
									</center>
									<hr/>
									<center>
										<Button bsStyle={this.getAvailabilityClass(this.state.availabilities.nantes.evening)} onClick={() => this.scheduleReservation("nantes", "evening")}>
											Soir : { this.state.availabilities.nantes.evening } places
										</Button>
									</center>
								</BPanel>
							</Col>

							<hr />
							<center>
								<p>Merci de sélectionner la période et le site de votre choix.
								</p>
							</center>
						</div>
					}
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={::this.closeProgramme}>Fermer</Button>
				</Modal.Footer>
			</Modal>
		);

	}

	render() {
		return (
			<div>
				<Button bsStyle="primary" onClick={::this.openProgramme}>Programmer</Button>
				{this.renderProgrammeModal()}
			</div>
		);
	}
}

CreateFlightComponent.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/component-create-flight.js
 **/